// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase : {
    apiKey: "AIzaSyACMJgrB2VewxnBptTpy0ghWgUPIEybdsE",
    authDomain: "solar-academy-18d4c.firebaseapp.com",
    projectId: "solar-academy-18d4c",
    storageBucket: "solar-academy-18d4c.appspot.com",
    messagingSenderId: "556642416360",
    appId: "1:556642416360:web:642189cfef45690f9d7b5d",
    measurementId: "G-3YQSKJFJP6"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
